"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastEditedCleanup = void 0;
var react_1 = __importStar(require("react"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var LegacyCombobox_1 = __importDefault(require("Common/LegacyCombobox/LegacyCombobox"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var IconToggle_1 = require("Common/IconToggle/IconToggle");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var AdminOnly_1 = require("Utils/AdminOnly");
var Types_1 = require("SettingsAngular/Reports/Types");
var c = (0, BemBuilder_1.default)("last-edited-cleanup");
function LastEditedCleanup(_a) {
    var onChange = _a.onChange, initialValue = _a.initialValue, className = _a.className, inSettingsPage = _a.inSettingsPage;
    var _b = __read((0, react_1.useState)({
        enabled: initialValue.enabled,
        lastEditedStr: String(initialValue.lastEditedDays),
    }), 2), internalValue = _b[0], setInternalValue = _b[1];
    var _c = __read((0, react_1.useState)(""), 2), error = _c[0], setError = _c[1];
    var onEnabledToggle = function () {
        var newValue = !internalValue.enabled;
        setInternalValue(__assign(__assign({}, internalValue), { enabled: newValue }));
        debouncedOnChange({
            enabled: newValue,
            lastEditedDays: Number(internalValue.lastEditedStr),
        });
    };
    var onInputValueChange = function (value) {
        setInternalValue(__assign(__assign({}, internalValue), { lastEditedStr: value }));
        var valueAsNumber = Number(value);
        if (value === "" || valueAsNumber < 0 || valueAsNumber > 366) {
            setError("Add a number between 0 to 366.");
        }
        else {
            setError("");
            debouncedOnChange({ enabled: internalValue.enabled, lastEditedDays: valueAsNumber });
        }
    };
    var debouncedOnChange = (0, react_1.useMemo)(function () { return (0, debounce_1.default)(onChange, 1000); }, [onChange]);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(IconToggle_1.IconToggle, { label: "Enable last edited", icon: react_1.default.createElement(icons_1.Edit, null), value: internalValue.enabled, onChange: onEnabledToggle }),
        internalValue.enabled && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: c("combobox-row") },
                react_1.default.createElement(kaleidoscope_1.Text, { className: c("combobox-pretext"), size: "s", element: "div", strong: true }, "Exclude pages last edited"),
                react_1.default.createElement(LegacyCombobox_1.default, { label: "Exclude pages last edited", placeholder: "", noResultsMessage: "", onSelect: function (entry) { return onInputValueChange(entry.label); }, renderInput: function (props) { return (react_1.default.createElement(kaleidoscope_1.TextInput, __assign({}, props, { className: c("combobox"), labelHidden: true, label: "Days", type: kaleidoscope_1.TextInputType.Number, onChange: onInputValueChange, endElement: react_1.default.createElement("div", { onFocus: props.onFocus, onBlur: props.onBlur },
                            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.ChevronDown, null), size: kaleidoscope_1.ButtonSize.Small })), value: internalValue.lastEditedStr, error: error }))); }, entries: [
                        { label: "14", value: "14", data: "14" },
                        { label: "30", value: "30", data: "30" },
                        { label: "60", value: "60", data: "60" },
                        { label: "90", value: "90", data: "90" },
                    ] })),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "days before the selected time period"),
            !inSettingsPage && (react_1.default.createElement(AdminOnly_1.AdminOnly, null,
                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", element: "p" },
                    react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/settings/reporting#".concat(Types_1.AnalyticsSettingSectionId.Cleanup) }, "Update the report default settings"),
                    ".")))))));
}
exports.LastEditedCleanup = LastEditedCleanup;
